export const FBI_FETCH_ALL_AGENTS = 'FBI_FETCH_ALL_AGENTS';
export const FBI_FETCH_ALL_AGENTS_START = `${FBI_FETCH_ALL_AGENTS}_START`;
export const FBI_FETCH_ALL_AGENTS_SUCCESS = `${FBI_FETCH_ALL_AGENTS}_SUCCESS`;
export const FBI_FETCH_ALL_AGENTS_FAILURE = `${FBI_FETCH_ALL_AGENTS}_FAIL`;

export const FLOW_RUN_LOCATION_AGENTS_CHANGED =
  'FLOW_RUN_LOCATION_AGENTS_CHANGED';
export const FLOW_RUN_LOCATION_AGENTS_CHANGED_SUCCESS = `${FLOW_RUN_LOCATION_AGENTS_CHANGED}_SUCCESS`;
export const FLOW_RUN_LOCATION_AGENTS_CHANGED_FAILURE = `${FLOW_RUN_LOCATION_AGENTS_CHANGED}_FAIL`;

export function fetchAgents() {
  return {
    type: FBI_FETCH_ALL_AGENTS,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents?status="ALL"',
      method: 'get',
    },
  };
}

export function changeAgents(flowBlockId, selectedAgents) {
  return {
    type: FLOW_RUN_LOCATION_AGENTS_CHANGED,
    payload: {
      flowBlockId,
      selectedAgents,
    },
  };
}
